module.exports = __webpack_public_path__ + "img/01n.54eef55d.png";